import { Divider } from '@mui/material';
import { withStyles } from '@mui/styles';

export default withStyles((theme) => {
  if (theme.palette.mode === 'dark') {
    return {
      root: {
        backgroundColor: '#3d454f',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
      }
    };
  }
  return {
    root: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    }
  };
})(Divider);
